<template>
  <div class='container login-container'>

    <div v-if="language === 'TC'" class='top-text'>
      為了提供更精準、科學的步態測試體驗，我們需要您填寫以下個人資訊。這些資訊將嚴格保密，僅用於本次測試的數據分析與個人化服務。請您放心填寫，感謝您的支持與配合！
    </div>
    <div v-else class='top-text en-height'>
      To provide a more accurate and scientific foot test result, please fill in the following information. This information will be kept confidential. This information will only be used for data analysis to generate your test result. Thank you for your and cooperation!
    </div>


    <div class="middle-box" :class="{en: language=== 'EN'}">
      <div class="input-row">
        <div class="middle-title">{{ language === 'TC' ? '1. 姓名' : '1. Name' }}</div>
        <input class='name-input' type="text" v-model='username' maxlength='40' />
      </div>

      <div class="input-row">
        <div class="middle-title">{{ language === 'TC' ? '2. 身高' : '2. Height' }}</div>
        <div class="inner-row">
          <input class='number-input' type="number" inputmode="decimal" min="1" max="250" step='0.1' v-model='height' />
          <span>{{ language === 'TC' ? '公分' : 'cm' }}</span>
        </div>    
      </div>

      <div class="input-row">
        <div class="middle-title">{{ language === 'TC' ? '3. 體重' : '3. Weight' }}</div>
        <div class="inner-row">
          <input class='number-input' type="number" inputmode="decimal" min="1" max="300" step='0.1' v-model='weight' />
          <span>{{ language === 'TC' ? '公斤' : 'kg' }}</span>
        </div>    
      </div>
      <div class="input-row">
        <div class="middle-title">{{ language === 'TC' ? '4. 性别' : '4. Gender' }}</div>
        <div class="inner-row">
          <div class='drop-down' @click="showGenderPopup = true">{{ language === 'TC' && gender === 1 ? '男' : language === 'TC' && gender === 2 ? '女' : gender === 1 ? 'Male' : gender === 2 ? 'Female' : '' }}</div>
          <img class="drop-down-img" src="../assets/image/drop-down.png" />
        </div>    
      </div>

      <img class="line" src="../assets/image/line.png" />

      <div class="middle-title">{{ language === 'TC' ? '5. 跑步頻率（單選）' : '5. Running Frequency (Single Choice)' }}</div>

      <div class='select-box'>
        <div class='select-item' :class="{ short: language === 'EN' }">
          <div class='check-box' @click="frequency = 1">
            <img src="../assets/image/red-check.png" v-if="frequency === 1" alt="">
          </div>
          <span>{{ language === 'TC' ? '平時不怎麼跑步' : 'Rarely run' }}</span>
        </div>
        <div class='select-item right' :class="{ long: language === 'EN' }">
          <div class='check-box' @click="frequency = 2">
            <img src="../assets/image/red-check.png" v-if="frequency === 2" alt="">
          </div>
          <span>{{ language === 'TC' ? '每周1-2次' : '1-2 times per week' }}</span>
        </div>

        <div class='select-item'>
          <div class='check-box' @click="frequency = 3">
            <img src="../assets/image/red-check.png" v-if="frequency === 3" alt="">
          </div>
          <span>{{ language === 'TC' ? '每周3-5次' : '3-5 times per week' }}</span>
        </div>
        <div class='select-item right'>
          <div class='check-box' @click="frequency = 4">
            <img src="../assets/image/red-check.png" v-if="frequency === 4" alt="">
          </div>
          <span>{{ language === 'TC' ? '天天跑步' : 'Run daily' }}</span>
        </div>
      </div>

      <img class="line" src="../assets/image/line.png"/>
      
      <div class="middle-title">{{ language === 'TC' ? '6. 跑步場景（單選）' : '6. Running Scenarios (Single Choice)' }}</div>

      <div class='select-box'>
        <div class='select-item full-row'>
          <div class='check-box' @click="scene = 1">
            <img src="../assets/image/red-check.png" v-if="scene === 1" alt="">
          </div>
          <span>{{ language === 'TC' ? '長距離慢跑（LSD）' : 'Long Slow Distance (LSD)' }}</span>
        </div>

        <div class='select-item'>
          <div class='check-box' @click="scene = 2">
            <img src="../assets/image/red-check.png" v-if="scene === 2" alt="">
          </div>
          <span>{{ language === 'TC' ? '日常有氧跑' : 'Easy run' }}</span>
        </div>
        <div class='select-item right'>
          <div class='check-box' @click="scene = 3">
            <img src="../assets/image/red-check.png" v-if="scene === 3" alt="">
          </div>
          <span>{{ language === 'TC' ? '間歇跑' : 'Interval run' }}</span>
        </div>

        <div class='select-item'>
          <div class='check-box' @click="scene = 4">
            <img src="../assets/image/red-check.png" v-if="scene === 4" alt="">
          </div>
          <span>{{ language === 'TC' ? '馬拉松比賽' : 'Marathon race' }}</span>
        </div>
        <div class='select-item right'>
          <div class='check-box' @click="scene = 5">
            <img src="../assets/image/red-check.png" v-if="scene === 5" alt="">
          </div>
          <span>{{ language === 'TC' ? '其它' : 'Others' }}</span>
        </div>
      </div>

      
    </div>

    <div class='bottom'>
      <span class="btn" :class="{ disabled: !username || !height || !weight || !frequency || !scene, en: language=== 'EN' }" @click="submit">{{ language === 'TC' ? '提交' : 'Submit' }}</span>
    </div>

    <div class="mask" v-if="showPopup">
      <div class='inner-mask'  @click="showPopup = false"></div>
      <div class="confirm-popup" :class="{en: language=== 'EN'}">
        <h1 v-if="language === 'TC'">店內運動員將在店內螢幕中<br>為您展示和講解該報告，<br>如您選擇不同意展示仍可進行測試。</h1>
        <h1 v-else>Your report will be displayed on the in-store screen and our store athlete will explain the report to you. You can still proceed with the test even if you choose not to have it displayed.</h1>
        <div class="btn-box">
          <span class="btn disagree" @click="toPlaying(0)">{{ language === 'TC' ? '不同意' : 'Disagree' }}</span>
          <span class="btn agree" @click="toPlaying(1)">{{ language === 'TC' ? '同意' : 'Agree' }}</span>
        </div>
      </div>
      
    </div>

    <div class="mask" v-if="showGenderPopup">
      <div class='inner-mask'  @click="showGenderPopup = false"></div>
      <div class="gender-popup" :class="{en: language=== 'EN'}">
        <div class="gender-header">
          <span class="cancel-btn" @click="showGenderPopup = false">{{ language === 'TC' ? '取消' : 'Cancel' }}</span>
          <span class="confirm-btn" @click="confirmGender">{{ language === 'TC' ? '確定' : 'Confirm' }}</span>
        </div>
        <div class="gender-options">
          <div class="gender-item" :class="{ active: selectedGender === 1 }" @click="selectedGender = 1">
            <span>{{ language === 'TC' ? '男' : 'Male' }}</span>
          </div>
          <div class="gender-item" :class="{ active: selectedGender === 2 }" @click="selectedGender = 2">
            <span>{{ language === 'TC' ? '女' : 'Female' }}</span>
          </div>
        </div>
      </div>
    </div>

    
   
  </div>

</template>

<script>
  import axios from 'axios'


  export default {
    data () {
      return {
        username: '',
        height: '',
        weight: '',
        frequency: 0,
        scene: 0,
        gender: 0,
        showPopup: false,
        showGenderPopup: false,
        selectedGender: 1,
      }
    },
    mounted(){
      
      
    },
    methods:{

      submit() {
        if ( !this.username || !this.height || !this.weight || !this.frequency || !this.scene || !this.gender ) {
          return
        }
        this.showPopup = true
      },

      confirmGender() {
        if (this.selectedGender) {
          this.gender = this.selectedGender
          this.showGenderPopup = false
        }
      },

      toPlaying(v) {
        var me = this

        let data = {
          timestamp: me.timestamp,
          openid: me.openid || `guest_${me.timestamp}`,
          name: me.username,
          shop_id: me.shopId,
          height: me.height,
          weight: me.weight,
          frequency: me.frequency,
          scene: me.scene,
          gender: me.gender,
          show_screen: v,
          play_time: me.formatDate(new Date()),
          lang: me.language,
        }
        console.log('data :>> ', data);
        axios({
          method: 'post',
          url: me.baseUrl + '/scanner',
          headers:{
            'Accept' :'application/json'
          },
          data: data
        }).then(res => {

          me.$router.replace({ path: "/playing" })
          
        }).catch(e => {
          console.log('toPlaying-e :>> ', e)
          me.$router.replace({ path: "/" })
        })

      },

      formatDate: function(date) {
        var date_ = new Date(date);
        var year = date_.getFullYear();
        var month = date_.getMonth() + 1;
        var day = date_.getDate();
        if (month < 10) month = "0" + month;
        if (day < 10) day = "0" + day;
      
        var hours = date_.getHours();
        var mins = date_.getMinutes();
        var secs = date_.getSeconds();
        if (hours < 10) hours = "0" + hours;
        if (mins < 10) mins = "0" + mins;
        if (secs < 10) secs = "0" + secs;
        return year + "-" + month + "-" + day + " " + hours + ":" + mins + ":" + secs
      },

    },


    computed: {
      language() {
        return this.$store.state.language
      },
      timestamp() {
        return this.$store.state.timestamp
      },
      openid() {
        return this.$store.state.openid
      },
      shopId() {
        return this.$store.state.shopId
      },
      baseUrl() {
        return this.$store.state.baseUrl
      },
    },

  }
</script>


<style lang="less" scoped>

  .login-container {
    background-color: #000;
    color: #fff;
  }

  .top-text {
    position: absolute;
    top: 15vw;
    left: 6.4vw;
    width: 87.2vw;
    font-size: 3.2vw;
    line-height: 5.3vw;
    font-family: 'fs-regular';
    &.en-height {
      line-height: 4.2vw;
      font-family: 'en-display';
    }
    
  }

  .middle-box {
    position: absolute;
    display: flex;
    flex-direction: column;
    top: 42vw;
    bottom: 20vw;
    left: 12.8vw;
    width: 74.6vw;
    overflow: auto;
    &.en {
      .middle-title {
        font-family: 'en-bold'
      }
      span {
        font-family: 'en-display';
      }
    }

    span {
      font-family: 'fs-regular';
    }

    .middle-title {
      font-size: 3.46vw;
      // letter-spacing: 1px;
      font-family: 'en-bold', 'fs-regular';
      font-weight: bold;
    }
    
    
    .input-row {
      position: relative;
      width: 100%;
      margin-bottom: 4.8vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      .name-input {
        width: 36.2vw;
        height: 6.67vw;
        background-color: #fff;
        color: #000;
        font-size: 4vw;
        box-sizing: border-box;
        font-weight: bold;
        text-align: center;
        font-family: 'en-bold';
      }

      .inner-row {
        position: relative;
        width: 36.2vw;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .number-input {
          width: 26.6vw;
          height: 6.67vw;
          background-color: #fff;
          color: #000;
          font-size: 4vw;
          box-sizing: border-box;
          font-weight: bold;
          text-align: center;
          font-family: 'en-bold';
        }
        
        span {
          font-size: 3.2vw;   
        }
      }

      .drop-down, .drop-down-img {
        width: 36.2vw;
        height: 6.67vw;
        line-height: 6.67vw;
      }
      .drop-down {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        color: #000;
        font-size: 4vw;
        font-weight: bold;
        text-align: center;
        font-family: 'en-bold';
      }
    }

    .select-box {
      position: relative;
      width: 100%;
      margin-top: 2.66vw;
      margin-bottom: 4.8vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      &:last-child {
        margin-bottom: 0;
      }
      .select-item {
        width: 50%;
        display: flex;
        align-items: center;
        margin: 2.66vw 0;
        &.short {
          width: 35%;
        }
        &.long {
          width: 65%;
        }
        &.full-row {
          width: 100%;
        }
        &.right {
          padding-left: 10.6vw;
        }
        .check-box {
          width: 4.26vw;
          height:4.26vw;
          margin-right: 2.66vw;
          background-color: #fff;
          img {
            width: 4.26vw;
            height: 4.26vw;
          }
        }
        span {
          font-size: 3.2vw;
          // font-family: 'en-medium';
        }
      }

    }

    .line {
      width: 73.3vw;
      margin: 1.6vw 0 6.4vw 0;
    }
    
  }


  .bottom {
    position: absolute;
    width: 100%;
    height: 10.67vw;
    z-index: 10;
    left: 0;
    bottom: 8vw;

    .btn {
      display: block;
      width: 87.2vw;
      height: 10.67vw;
      margin: 0 auto;
      background-color: #fff;
      color: #000;
      border-radius: 8vw;
      font-size: 3.7vw;
      line-height: 10.67vw;
      text-align: center;
      font-weight: bold;
      font-family: 'fs-bold';
      &.en {
        font-family: 'en-bold';
      }
      &.disabled {
        opacity: 0.3;
      }
    }


  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 500;
    background: rgba(0, 0, 0, 0.7);
    .inner-mask {
      width: 100%;
      height: 100%; 
    }

    .confirm-popup {
      position: fixed;
      z-index: 1000;
      top: 60vw;
      left: 12vw;
      width: 76vw;
      height: 58.6vw;
      background-color: #141414;
      display: flex;
      flex-direction: column;
      border-radius: 30px;
      &.en {
        h1 {
          font-family: 'en-medium';
          font-weight: normal;
          margin-top: 11vw;
          margin-bottom: 7vw;
        }
        .btn-box {
          font-family: 'en-bold';
        }
      }

      h1 {
        font-weight: 500;
        text-align: center;
        width: 100%;
        text-align: center;
        font-size: 3.4vw;
        margin-top: 16vw;
        margin-bottom: 10vw;
        line-height: normal;
        color: #fff;
        font-family: 'fs-medium';
        padding: 0 10vw;
      }


      .btn-box {
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'fs-bold';
        .disagree {
          width: 32vw;
          height: 10.7vw;
          margin-right: 3vw;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1.5px solid #fff;
          border-radius: 60px;
          color: #fff;
          font-size: 3.2vw;
          font-weight: bold;

        }
        .agree {
          width: 32vw;
          height: 10.7vw;
          margin-right: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color:  #fff;
          border-radius: 60px;
          color: #000;
          font-size: 3.2vw;
          font-weight: bold;
        }
      }
    }

    .gender-popup {
      position: fixed;
      z-index: 1000;
      bottom: 0vw;
      left: 0vw;
      width: 100vw;
      height: 50vw;
      background-color: #141414;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;
      &.en {
        .gender-header {
          font-family: 'en-bold';
        }
        .gender-options {
          .gender-item {
            span {
              font-family: 'en-medium';
            }
          }
        }
      }

      .gender-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5vw 6vw;
        font-weight: bold;

        .cancel-btn {
          font-size: 3.7vw;
          color: #fff;
        }

        .confirm-btn {
          font-size: 3.7vw;
          color: #ff0000;
        }
      }

      .gender-options {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        // height: calc(100% - 10vw);

        .gender-item {
          width: 100%;
          height: 14vw;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          span {
            font-size: 4.8vw;
            color: #fff;
            opacity: 0.3;
            font-weight: 500;
          }
          &.active {
            span {
              opacity: 1;
            }
          }
        }
      }
    }
  }

  





</style>



// WEBPACK FOOTER //
// src/pages/form.vue